// The range `POST /qr-batches` accepts (`400 invalid_qr_amount` outside it), checked here first so
// the field can say so before anything is sent.
export const MIN_QR_AMOUNT = 1;
export const MAX_QR_AMOUNT = 100_000;

// Digits only: a decimal, a sign, an exponent or a thousands separator is not a count of labels,
// and guessing what «1.000» meant is how a batch of 1 gets printed instead of 1000.
const DIGITS = /^\d+$/;

export function parseQuantity(raw: string): number | null {
  const trimmed = raw.trim();
  if (!DIGITS.test(trimmed)) return null;
  const amount = Number(trimmed);
  return amount >= MIN_QR_AMOUNT && amount <= MAX_QR_AMOUNT ? amount : null;
}
